"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var keautils_1 = require("keautils");
/**
 * Componente que toma como entrada un observable de elementos JSX y los dibuja
 */
var RxToReact = /** @class */ (function (_super) {
    __extends(RxToReact, _super);
    function RxToReact(props) {
        var _this = _super.call(this, props) || this;
        _this.firstRender = false;
        _this.onNext = function (x) {
            if (_this.firstRender) {
                _this.setState({
                    value: x,
                    setted: true
                });
            }
            else {
                _this.state = __assign({}, _this.state, { value: x });
            }
        };
        _this.state = {
            value: null,
            observable: undefined,
            oldValue: undefined,
            subscription: undefined,
            onNext: _this.onNext,
            setted: false
        };
        return _this;
    }
    RxToReact.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.value != prevState.oldValue) {
            //Quitar la subscripción anterior
            if (prevState.subscription != null) {
                prevState.subscription.unsubscribe();
            }
            var nextPropsVal = nextProps.value;
            if (nextPropsVal != null && keautils_1.isObservable(nextPropsVal)) {
                var siguienteValor_1 = undefined;
                //Esta variable determina si el onNext se llamo después del subscribe, si es true, significa que el onNext se llamo en el mismo instante que la llamada del subscribe
                var siguienteValorInstantaneo_1 = true;
                var onNext = function (next) {
                    siguienteValor_1 = next;
                    //Si el onNext fue instantaneo, no llamamos al onNext ya que será suficiente con devolver el nuevo state
                    if (!siguienteValorInstantaneo_1) {
                        prevState.onNext(next);
                    }
                };
                var newSubscription = nextPropsVal.subscribe(onNext);
                siguienteValorInstantaneo_1 = false;
                return __assign({}, prevState, { oldValue: nextPropsVal, value: (siguienteValor_1 != undefined) ? siguienteValor_1 : prevState.value, subscription: newSubscription, observable: nextPropsVal });
                return null;
            }
            else {
                return __assign({}, prevState, { value: nextPropsVal, oldValue: nextPropsVal, observable: undefined, subscription: undefined });
            }
        }
        else {
            return prevState;
        }
    };
    RxToReact.prototype.componentWillUnmount = function () {
        if (this.state.subscription)
            this.state.subscription.unsubscribe();
    };
    RxToReact.prototype.render = function () {
        this.firstRender = true;
        var val = this.props.value;
        //Si el valor que nos pasan es un ReactElement, lo dibujamos directamente:
        if (keautils_1.isObservable(val)) {
            return this.state.value || null;
        }
        else {
            return val || null;
        }
    };
    return RxToReact;
}(React.PureComponent));
exports.RxToReact = RxToReact;
//# sourceMappingURL=rxToReact.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-rxk/dist/rxToReact.js
// module id = 711
// module chunks = 0